<template>
  <div>
    <b-alert variant="warning" show class="p-1 d-flex" v-if="show_alert">
      <div class="mr-1"><feather-icon icon="AlertTriangleIcon" size="20"/></div>
      <div>
        {{$t('invitation.dont_forget_tyc')}}
      </div>
    </b-alert>
    <p class="avenir-medium">{{$t('invitation.textTerms')}}</p>
    <b-form @submit.prevent="acceptTerms()">
      <b-form-checkbox
        v-if="!campaign_influencer.accept_tyc"
        v-model="accept_terms"
        :disabled="disable_check"
        switch
      >
        <p>{{$t('invitation.acceptTerms')}} <b-link @click="openModal" class="text-blue" variant="text-blue">{{$t('invitation.linkTerms')}}</b-link></p>
      </b-form-checkbox>
      <div v-else>
        <p>{{$t('invitation.alreadyAccept')}} <b-link @click="openModal" class="text-blue" variant="text-blue">{{$t('invitation.linkTerms')}}</b-link></p>
      </div>
      <div class="d-flex justify-content-end mt-1">
        <b-button variant="outline-secondary" @click="$emit('close_modal_tyc')">{{ $t("tracking.cancel") }}</b-button>
        <b-button type="submit" variant="blue-button" class="blue-button ml-1">{{ $t("campaigns.confirmButton") }}</b-button>
      </div>
    </b-form>

    <modal-brandme size="lg" :show_modal="show_modal" :key="change_modal">
      <template #title>
        <span>{{$t('invitation.titleTerms')}}</span>
      </template>
      <template #body>
        <text-terms-and-condition @redirect="acceptTermsEmit"/>
      </template>
    </modal-brandme>
  </div>
</template>

<script>
import { BFormCheckbox, BLink, BForm, BButton, BAlert } from "bootstrap-vue";
import invitation_service from "@/services/invitation";

export default {
  name: 'accpetTerms',
  components: {
    BFormCheckbox,
    BLink,
    BForm,
    BButton,
    BAlert,
    ModalBrandme: () => import('@/views/components/modal/ModalBrandme.vue'),
    TextTermsAndCondition: () => import('@/views/pages/authentication/TextTermsAndCondition.vue')
  },
  props: {
    campaign: {
      required: true,
      type: Object,
    },
  },
  data() {
    return {
      disable_check: false,
      accept_terms: false,
      show_modal: false,
      change_modal: false,
      influencer: this.campaign.campaign_influencer.influencer,
      campaign_influencer: this.campaign.campaign_influencer,
      show_alert: false,
    }
  },
  created() {
  },
  methods: {
    acceptTermsEmit() {
      this.accept_terms = true;
      this.acceptTerms();
    },
    openModal(evt) {
      evt.preventDefault()
      this.show_modal = true;
      this.change_modal = !this.change_modal
    },
    acceptTerms() {
      if (!this.accept_terms) {
        this.show_alert = true;
        return;
      }
      this.disable_check = true
      invitation_service.accpetTerms(this.$route.params.slug, this.$route.params.network, this.$route.params.username).then(() => {
        this.campaign_influencer.accept_tyc = true;
        this.disable_check = false;
        this.$emit('close_modal_tyc');
        this.$emit('accept_terms');
      })
    }
  },
};
</script>

<style>
  .title-terms {
    color: #545454;
    margin-bottom: 10px;
    margin-top: 30px;
    font-weight: 500;
    font-size: 20px;
    font-family: 'Gilroy-ExtraBold';
  }
</style>
